import { Box, Typography } from "@mui/material";
import zIndex from "@mui/material/styles/zIndex";
import Button from "../inputs/Button";

const MessageBox = ({ children, acceptText, cancelText, onAccept, onCancel }) => {
  return (
    <Box
      style={{
        position: "absolute",
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 1100,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backdropFilter: "blur(10px)",
        padding: "10px",
      }}
    >
      <Box
        style={{
          backgroundColor: "#181A20",
          borderRadius: "15px",
          display: "flex",
          flexDirection: "column",
          padding: "10px",
          maxWidth: "400px",
          gap: "20px",
        }}
      >
        {children}
        <Box style={{ display: "flex", width: "100%", justifyContent: "space-between", gap: "20px" }}>
          {cancelText && (
            <Button onClick={onCancel} stroked>
              {cancelText}
            </Button>
          )}
          {acceptText && <Button onClick={onAccept}>{acceptText}</Button>}
        </Box>
      </Box>
    </Box>
  );
};

export default MessageBox;
